export function sellerAdvisoryResidentialCP1225() {
return [   // Release 2026-01-14 14:17:26
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 62.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Seller Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 171.6,
   width: 353.64,
   height: 10.20
}
,
{
   page: 0,
   name: "Seller Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 182.146,
   left: 179.346,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 208.328,
   left: 179.346,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 235.819,
   left: 179.346,
   width: 356.837,
   height: 14.146
}
,
{
   page: 0,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 262.001,
   left: 179.346,
   width: 356.837,
   height: 14.146
}
,
{
   page: 1,
   name: "Seller Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 171.6,
   width: 353.64,
   height: 10.20
}
,
{
   page: 1,
   name: "Seller Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 2,
   name: "Seller Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 171.6,
   width: 353.64,
   height: 10.20
}
,
{
   page: 2,
   name: "Seller Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 3,
   name: "Seller Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 171.6,
   width: 353.64,
   height: 10.20
}
,
{
   page: 3,
   name: "Seller Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 4,
   name: "Seller Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 171.6,
   width: 353.64,
   height: 10.20
}
,
{
   page: 4,
   name: "Seller Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
,
{
   page: 5,
   name: "Seller Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 171.6,
   width: 353.64,
   height: 11.40
}
,
{
   page: 5,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 410.8,
   left: 72.0,
   width: 214.92,
   height: 13.091
}
,
{
   page: 5,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 410.8,
   left: 296.88,
   width: 76.68,
   height: 13.091
}
,
{
   page: 5,
   name: "Signature Seller Broker 13", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 77.52,
   width: 291.36,
   height: 10.20
}
] }
